module.exports = __webpack_public_path__ + "img/unicon.6a93faee.png";